import { memo } from 'react'
import { Handle, Position } from 'reactflow'
import type { NodeProps } from 'reactflow'
import { AGENT_ROLE_COLORS, STATUS_COLORS } from '../../../../lib/agentColors'

export interface AgentNodeData {
  label: string
  agentId: string | null
  team: string
  agentRole: string
  description: string
  isRouter?: boolean
  status?: 'pending' | 'running' | 'success' | 'error'
  tokens_used?: number
  duration_ms?: number
  output_preview?: string | null
}

export const AgentNode = memo(({ data, selected }: NodeProps<AgentNodeData>) => {
  const roleColor = AGENT_ROLE_COLORS[data.agentRole] ?? '#6B7280'
  const status = data.status ?? 'pending'
  const statusStyle = STATUS_COLORS[status]

  return (
    <div
      className={`rounded-xl border-2 min-w-[160px] max-w-[200px] transition-all ${selected ? 'ring-2 ring-offset-1 ring-emerald-400' : ''}`}
      style={{
        borderColor: data.status ? statusStyle.border : roleColor,
        backgroundColor: data.status ? statusStyle.bg : '#FFFFFF',
      }}
    >
      <Handle type="target" position={Position.Left} className="w-2 h-2" />

      <div className="px-3 py-2.5">
        <div
          className="w-1.5 h-1.5 rounded-full mb-1.5"
          style={{ backgroundColor: roleColor }}
        />
        <p className="text-xs font-semibold text-slate-800 leading-tight">{data.label}</p>
        <p className="text-xs text-slate-400 mt-0.5 leading-tight">{data.description}</p>

        {data.tokens_used !== undefined && data.tokens_used > 0 && (
          <div className="mt-1.5 flex items-center gap-2">
            <span className="text-xs text-slate-400">{data.tokens_used.toLocaleString()} tok</span>
            {data.duration_ms !== undefined && data.duration_ms > 0 && (
              <span className="text-xs text-slate-400">{(data.duration_ms / 1000).toFixed(1)}s</span>
            )}
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Right} className="w-2 h-2" />
    </div>
  )
})

AgentNode.displayName = 'AgentNode'
